export const state = () => ({
    declareCompany: {},
    birthCountryDirector: false
   
})  